/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Method_1Inputs */

const en_fw_bm_method_1 = /** @type {(inputs: Fw_Bm_Method_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One row per task: the first evidence run after the agent claimed it. Pass = every acceptance criterion green, no override.`)
};

const id_fw_bm_method_1 = /** @type {(inputs: Fw_Bm_Method_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu baris per task: bukti pertama setelah agen mengambilnya. Lolos = semua kriteria penerimaan hijau, tanpa override.`)
};

/**
* | output |
* | --- |
* | "One row per task: the first evidence run after the agent claimed it. Pass = every acceptance criterion green, no override." |
*
* @param {Fw_Bm_Method_1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_method_1 = /** @type {((inputs?: Fw_Bm_Method_1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Method_1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_method_1(inputs)
	return en_fw_bm_method_1(inputs)
});